
import Vue from 'vue';
import IllinoisTabBar from './TabBar.vue';
import IllinoisIcons from './icons.vue';

export default Vue.extend({
  name: 'IllinoisHeader',
  components: {
    IllinoisIcons
  },
  data() {
    return {
      tabItems: [
        { label: 'Sports', value: 'sports' },
        { label: 'Daily Lineup', value: 'lineup' },
        { label: 'Extra', value: 'extra' }
      ],
      barWidthPx: 0 as number,
      barLeftPx: 0 as number,
      showOddsTypeDropdown: false as boolean,
      dropdownStyle: {} as Record<string, string>
    };
  },

  computed: {
    isLivePage(): boolean {
      return this.$route.path.includes('/live');
    },
    currentOddsType(): string {
      return this.$store.getters['odds/getOddsType'] || 'decimal';
    }
  },
  async mounted() {
    await this.$nextTick();
    this.updateBarWidth();
    window.addEventListener('resize', this.updateBarWidth, {
      passive: true
    } as any);
    document.addEventListener('click', this.handleClickOutside);
    this.$watch(
      () => this.$route.path,
      async () => {
        await this.$nextTick();
        this.updateBarWidth();
      }
    );
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateBarWidth as any);
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    updateBarWidth(): void {
      const sportRef: any = this.$refs.allSportsLink as any;
      const liveRef: any = this.$refs.liveLink as any;
      const containerRef: any = this.$refs.tabsContainer as any;
      const sportTextRef: any = this.$refs.allSportsText as any;

      const sportEl: HTMLElement | null = sportRef
        ? (sportRef.$el as HTMLElement) || (sportRef as HTMLElement)
        : null;
      const liveEl: HTMLElement | null = liveRef
        ? (liveRef.$el as HTMLElement) || (liveRef as HTMLElement)
        : null;
      const containerEl: HTMLElement | null = containerRef
        ? (containerRef.$el as HTMLElement) || (containerRef as HTMLElement)
        : null;
      const sportTextEl: HTMLElement | null = sportTextRef
        ? (sportTextRef.$el as HTMLElement) || (sportTextRef as HTMLElement)
        : null;

      if (!sportEl || !liveEl) {
        this.barWidthPx = 0;
        return;
      }

      const targetEl = this.isLivePage ? liveEl : sportTextEl || sportEl;
      const secondEl = this.isLivePage ? null : liveEl;

      if (containerEl && targetEl) {
        const cRect = containerEl.getBoundingClientRect();
        const tRect = targetEl.getBoundingClientRect();
        this.barLeftPx = tRect.left - cRect.left;
      } else {
        this.barLeftPx = 0;
      }

      this.barWidthPx = this.isLivePage
        ? targetEl.offsetWidth
        : sportTextEl?.offsetWidth || sportEl.offsetWidth || 0;
    },
    toggleOddsTypeDropdown(): void {
      this.showOddsTypeDropdown = !this.showOddsTypeDropdown;
      if (this.showOddsTypeDropdown) {
        this.$nextTick(() => {
          this.calculateDropdownPosition();
        });
      }
    },
    handleOddsTypeChange(value: string): void {
      this.$store.commit('odds/SET_ODDS_TYPE', value);
      this.showOddsTypeDropdown = false;
      window.parent.postMessage(
        {
          type: 'oddsTypeChanged',
          oddsType: value
        },
        '*'
      );
    },
    handleClickOutside(event: Event): void {
      const container = this.$refs.dropdownContainer as HTMLElement;
      if (container && !container.contains(event.target as Node)) {
        this.showOddsTypeDropdown = false;
      }
    },
    calculateDropdownPosition(): void {
      const container = this.$refs.dropdownContainer as HTMLElement;
      const dropdown = this.$refs.dropdownContent as HTMLElement;
      if (!container || !dropdown) return;

      const containerRect = container.getBoundingClientRect();
      const dropdownRect = dropdown.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - containerRect.bottom;

      // Se c'è spazio sotto, mostra il dropdown sotto
      if (spaceBelow >= dropdownRect.height || spaceBelow > containerRect.top) {
        this.dropdownStyle = {
          top: '100%',
          right: '0',
          marginTop: '0.25rem'
        };
      } else {
        // Altrimenti mostra sopra
        this.dropdownStyle = {
          bottom: '100%',
          right: '0',
          marginBottom: '0.25rem'
        };
      }
    }
  }
});
